import { FormControl, MenuItem, OutlinedSelectProps, Select as MuiSelect, Stack, Typography } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import styles from './Select.module.css';
import SelectOption from '../../../../../@types/SelectOption';

interface SelectProps extends OutlinedSelectProps {
  name: string;
  label: string;
  description?: string;
  options: SelectOption[];
  placeholder?: string;
  value?: SelectOption;
  defaultValue?: SelectOption[];
  placeholderValue?: string | number;
  handleOnChange?: (value: string | number | string[]) => void;
}

const Select = ({ name, label, description, options, placeholder, placeholderValue, value, defaultValue, handleOnChange, ...props }: SelectProps) => {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      defaultValue=""
      control={control}
      render={({ field, fieldState }) => (
        <FormControl
          sx={{ minWidth: '225px', width: "100%" }}
          className={styles.SelectWrapper}>
          <Stack
            direction="column"
            spacing={0.5}
            width="100%">
            <Typography variant="primaryFont">
              {label}
            </Typography>
            <MuiSelect
              {...props}
              sx={(theme) => ({
                minWidth: '225px',
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.colors.primary,
                  borderWidth: '2px'
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.colors.primary,
                  borderWidth: '2px'
                }
              })}
              {...field}
              displayEmpty
              onChange={(event) => {
                field.onChange(event.target.value);
                field.onBlur();
                if (handleOnChange) handleOnChange(event.target.value);
              }}
              value={value ? value.value : field.value}
              className={styles.Select}
            >
              {placeholder &&
                <MenuItem disabled value={placeholderValue ?? ''}>
                  <em className={styles.PlaceHolder}>{placeholder}</em>
                </MenuItem>
              }
              {options.map((option, index) =>
                <MenuItem
                  key={index}
                  value={option.value}
                  disabled={option.disabled}>
                  {option.label} {option.disabled && option.disabledMessage ? option.disabledMessage : ''}
                </MenuItem>
              )}
            </MuiSelect>
            <Typography variant="errorFont">
              {fieldState.error?.message}
            </Typography>
            {description &&
              <Typography>{description}</Typography>
            }
          </Stack>
        </FormControl>
      )}
    />
  );
}

export default Select;